import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
window.$ = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
import './lib/slick/slick';
import './lib/magnific-popup/jquery.magnific-popup';
import './lib/smoothscroll';

import CallbackForm from './indexEntry/modules/callback-form'

new CallbackForm();

import AOS from 'aos';

AOS.init();

$(document).foundation();

$('#mainPageCarousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
});

// $('.partners-carousel').slick({
//     slidesToShow: 5,
//     slidesToScroll: 5,
//     prevArrow: false,
//     nextArrow: false,
//     dots: true,
//     autoplay: false,
//     rows: 3,
//     infinite: false,
//     responsive: [
//         {
//             breakpoint: 640,
//             settings: {
//                 slidesToShow: 2,
//                 slidesToScroll: 2,
//                 infinite: false
//             }
//         }
//     ]
// });


$('.menu-icon-block').on('click', function () {
    $('body').toggleClass('menu-active');
});

$('#mainMenu .close-button').on('click', function () {
    $('body').removeClass('menu-active');
});

$('#byProjects li.all').on('click', function () {
    $('#byProjects li').not(this).removeClass('active');
    $(this).addClass('active');
});

$('#byProjects li').not($('#byProjects li.all')).on('click', function () {
    $(this).addClass('active');
    $('#byProjects li.all, #byProjects li').not(this).removeClass('active');
});


if ($('.service-item .section-body').height() < 300) {
    $('.service-item .left-section .btn-show-more').hide();
} else {
    $('.service-item .section-body').addClass('full-length');
    $('.service-item .left-section .btn-show-more').on('click', function () {
        $('.service-item .section-body').toggleClass('full-length');

        var btn = document.querySelector(".service-item .btn-show-more span");
        if (btn.innerHTML === "ПОКАЗАТИ МЕНШЕ") {
            btn.innerHTML = "ПОКАЗАТИ БІЛЬШЕ";
        } else {
            btn.innerHTML = "ПОКАЗАТИ МЕНШЕ";
        }

    });
}

if ($('.news-article') && $('.popup-link').length > 0) {
    $('.popup-link').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: true
    });
}